<template>
    <div class="convenience-fee-overview">
        <div class="convenience-fee-overview__container" tabindex="0">
            <span class="convenience-fee-overview__title">
                {{ $ml.get('convenienceFee') }}
                <InfoTooltip
                    :items="['convenienceFeeInfoTooltip']"
                    :icon-color="'gray'"
                    :orientation="'top'"
                />
            </span>
            <span class="convenience-fee-overview__price">
                {{
                    selectedConvenienceFee
                        ? formatPrice(selectedConvenienceFee)
                        : $ml.get('convenienceFeeEmpty')
                }}
            </span>
        </div>
    </div>
</template>

<script>
    import moneyHelper from '@/helpers/moneyHelper';
    import { mapGetters } from 'vuex';

    import InfoTooltip from '@/components/InfoTooltip';

    export default {
        components: {
            InfoTooltip
        },

        computed: {
            ...mapGetters({
                selectedConvenienceFee: 'convenienceFee/getSelectedConvenienceFee',
			})
        },

        methods: {
            formatPrice(unitPrice) {
              let totalPrice = unitPrice;

              return `R$ ${moneyHelper.formatToPrice(totalPrice)}`;
          }
        }
    };
</script>

<style lang="scss" scoped>
    .convenience-fee-overview {
        &__container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            line-height: 16px;
            font-weight: 500;
            color: #5C6A7B;
        }

        &__title {
            display: flex;
            align-items: center;

            .it {
                margin-left: 8px;
            }
        }

        &__price {}
    }
</style>
